import React from 'react';
import { AddonProductType } from '@dtp/membership-service-types';
import { UseFormReturn } from 'react-hook-form';
import { useStateMachine } from 'little-state-machine';
import useSelector from '@redux/typedHooks';
import { useTrackProductsCart } from '../../../../../hooks/useTrackProductItem';
import { updateAction } from '../../../lib/updateAction';
import {
  didUseVippsMembershipRegistrationMethod,
  getVippsMembershipRegistrationMethodTrackingPayload,
} from '../../../components/VippsModal/VippsModal.utils';
import type { AddonFormMember } from '../Addons.utils';
import S from './Styles';
import { AddonProductField } from './AddonProductField';

interface Props {
  availableAddOnProducts?: (AddonProductType & { isRequiredAddOn?: boolean })[];
  membersOverride?: AddonFormMember[];
  control: UseFormReturn['control'];
  handleSubmit: UseFormReturn['handleSubmit'];
  onSubmit?: (values: Record<string, string | string[] | boolean | undefined>) => any;
  errors: UseFormReturn['formState']['errors'];
  watch: UseFormReturn['watch'];
  setValue: UseFormReturn['setValue'];
  getValues: UseFormReturn['getValues'];
  unregister: UseFormReturn['unregister'];
}

export const AddonForm = ({ onSubmit, availableAddOnProducts, membersOverride, handleSubmit, ...form }: Props) => {
  const {
    state: { membersForm, addonsForm },
  } = useStateMachine({ updateAction });
  const registrationMethod = getVippsMembershipRegistrationMethodTrackingPayload(
    didUseVippsMembershipRegistrationMethod(),
  ).checkout_registration_method;
  const campaignCode = useSelector((state) => state.becomeAMember?.data?.campaignCodeDetails?.campaignCode);
  const tracking = useTrackProductsCart(registrationMethod, campaignCode);
  const members = membersOverride || [membersForm.mainMember, ...(membersForm.otherMembers || [])];

  return (
    <S.StyledForm onSubmit={() => onSubmit && handleSubmit(onSubmit)}>
      {availableAddOnProducts?.map((product) => (
        <AddonProductField
          key={product.productNumber}
          product={product}
          members={members}
          storedMembers={addonsForm[product.productNumber]?.members}
          tracking={tracking}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...form}
        />
      ))}
    </S.StyledForm>
  );
};
